module.exports = __webpack_public_path__ + "static/img/training_system_s2_max3.49ff973c.png";